const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Ticket24 = function Ticket24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.076 12.542h-2.414c.081.516.597.733 1.03.733.272 0 .516-.055.76-.163l-.054.732a2.535 2.535 0 0 1-.922.163c-1.085 0-1.844-.624-1.844-1.709 0-.922.678-1.627 1.708-1.627 1.166 0 1.763.732 1.736 1.871Zm-4.394 1.383a3.072 3.072 0 0 1-.19-.488l-.135-.488c-.081-.244-.163-.352-.407-.352h-.407v1.328h-.922V9.614h.922V12h.109l.895-1.275h1.03l-1.057 1.33h.054c.407 0 .542.243.65.569l.19.596c.055.217.19.543.299.705h-1.03ZM10.7 13.22a1.3 1.3 0 0 0 .597-.135l-.081.786c-.19.109-.461.136-.706.136-1.003 0-1.708-.651-1.708-1.682 0-1.003.678-1.654 1.708-1.654.38 0 .651.082.95.217l-.271.732a1.07 1.07 0 0 0-.543-.162c-.515 0-.84.325-.84.867-.028.516.325.895.894.895Zm-3.146-2.9h.949v-.705h-.95v.705Zm0 3.606h.949v-3.2h-.95v3.2Zm10.711-1.735v-2.17l.95-.38v1.14h.65l-.135.705h-.515v.732c0 .705.27 1.22.57 1.627.135-.596.216-1.22.216-1.871 0-4.393-3.58-7.973-8-7.973a7.976 7.976 0 0 0-7.62 5.614h2.983l-.109.867H6.008v3.472h-1.03v-3.499h-.814c-.109.488-.136 1.004-.136 1.519a7.997 7.997 0 0 0 15.756 1.952h-.95c-.189-.298-.569-.813-.569-1.735Zm-1.898-.868c-.407 0-.65.271-.732.624h1.437c-.054-.407-.325-.624-.705-.624Z",
      fill: "#D52B1E",
    })
  );
};
Ticket24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Ticket32 = function Ticket32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M16 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.076 12.542h-2.414c.081.516.597.733 1.03.733.272 0 .516-.055.76-.163l-.054.732a2.535 2.535 0 0 1-.922.163c-1.085 0-1.845-.624-1.845-1.709 0-.922.678-1.627 1.709-1.627 1.166 0 1.763.732 1.736 1.871Zm-4.394 1.383a3.072 3.072 0 0 1-.19-.488l-.135-.488c-.081-.244-.163-.352-.407-.352h-.407v1.328h-.922V9.614h.922V12h.109l.895-1.275h1.03l-1.057 1.33h.054c.407 0 .542.243.65.569l.19.596c.055.217.19.543.299.705h-1.03ZM14.7 13.22a1.3 1.3 0 0 0 .597-.135l-.081.786c-.19.109-.461.136-.706.136-1.003 0-1.708-.651-1.708-1.682 0-1.003.678-1.654 1.708-1.654.38 0 .651.082.95.217l-.271.732a1.07 1.07 0 0 0-.543-.162c-.515 0-.84.325-.84.867-.028.516.325.895.894.895Zm-3.145-2.901h.949v-.705h-.95v.705Zm0 3.606h.949v-3.2h-.95v3.2Zm10.711-1.735v-2.17l.95-.38v1.14h.65l-.135.705h-.515v.732c0 .705.27 1.22.57 1.627.135-.596.216-1.22.216-1.871 0-4.393-3.58-7.973-8-7.973a7.976 7.976 0 0 0-7.62 5.614h2.983l-.109.867h-1.247v3.472h-1.03v-3.499h-.814c-.109.488-.136 1.004-.136 1.519a7.997 7.997 0 0 0 15.756 1.952h-.95c-.189-.298-.569-.813-.569-1.735Zm-1.898-.868c-.407 0-.65.271-.732.624h1.437c-.054-.407-.325-.624-.705-.624Z",
      fill: "#D52B1E",
    })
  );
};
Ticket32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Ticket24,
  32: Ticket32,
};
export function Ticket(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Ticket' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
